<template>
  <div class="outer-container">
    <div class="container">
      <h5>Sobre esta aplicação</h5>
      <p>
        O minhamola é uma aplicação para o rastreio de entradas e saídas de dinheiro das tuas contas
        pessoais.
      </p>
      <p>
        Esta aplicação foi desenvolvida com o intuito de oferecer aos cidadãos moçambicanos uma
        aplicação similar às que são comumente usadas nos países de primeiro mundo, sendo que esta
         diferencia-se das demais por sua natureza simples e interface intuitiva, a
        utilização do portugues como língua principal da aplicação e o fato de estar talhada a
        realidade moçambicana.
      </p>
      <p>
        Registe um número ilimitado de contas, adicione as entradas e saidas de cada
        uma delas, veja o histórico das transacções e muito mais.
      </p>
      <AppButton text="Voltar" @click.native="goBack" />
    </div>
    <TheFooter />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AppButton from "../components/AppButton.vue";
import TheFooter from "../components/TheFooter.vue";

export default {
  name: "TheAbout",
  components: {
    AppButton,
    TheFooter
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(["changeMenuStatus"]),
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
button {
  margin: 1.8rem auto;
  background-color: var(--color-primary);
  color: var(--color-quaternary);
}

.outer-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

footer {
  margin-top: auto;
}

.container {
  display: flex;
  flex-direction: column;
}

h5 {
  margin-bottom: 0.8rem;
}

p {
  color: var(--color-tertiary);
  margin-bottom: 0.8rem;
}
</style>
